// // 全局组件配置

import Header from './header/Header' // 头部组件
import cateNav from './nav/CateNav' // 个人中心 卡片
// empty.install = function (Vue) {
//   Vue.component('empty', empty)
// }

// drawer.install = function (Vue) {
//   Vue.component('drawer', drawer)
// }

Header.install = function (Vue) {
  Vue.component('BaseHeader', Header)
}

// FixedTopPage.install = function (Vue) {
//   Vue.component('FixedTopPage', FixedTopPage)
// }

// Footer.install = function (Vue) {
//   Vue.component('BaseFooter', Footer)
// }

// Search.install = function (Vue) {
//   Vue.component('Search', Search)
// }

// card.install = function (Vue) {
//   Vue.component('card', card)
// }

cateNav.install = function (Vue) {
  Vue.component('cateNav', cateNav)
}

// 引用本js中所有的组件
export function InstallAll (Vue) {
  Vue.use(Header)
  Vue.use(cateNav)
}



// WEBPACK FOOTER //
// ./src/components/global.js